export const ACTIONS_COLUMN_DEF = 'actions' as const
export const WIDTH = 45
